export default __webpack_public_path__ + "static/media/checkboxButton.e430df5a.svg";